import { toast } from 'sonner';

const DURATION_OK = 4000;
/** Erros ficam um pouco mais tempo para leitura. */
const DURATION_ERR = 6000;

/** Toasts no canto superior direito (configurado em `<Toaster />`) e some sozinho após alguns segundos. */
export const feedback = {
  success(message: string) {
    toast.success(message, { duration: DURATION_OK });
  },
  error(message: string) {
    toast.error(message, { duration: DURATION_ERR });
  },
  warning(message: string) {
    toast.warning(message, { duration: DURATION_ERR });
  },
  message(message: string) {
    toast.message(message, { duration: DURATION_OK });
  },
};
